/* Rastreio de pedidos (sections/rastreio-pedidos.liquid). Sem dependências; o mapa 3D
 * (assets/rastreio-pedidos-mapa.js, Three.js) só é carregado quando vai aparecer.
 *
 * A consulta vai para o endpoint da seção (webhook) como
 *   POST { tipo: "cpf" | "pedido", valor: "<só dígitos>", token: "<Turnstile>" }
 * e espera { cliente: { nome, documento }, destaque, pedidos: [...] } com os dados
 * pessoais já mascarados no servidor. 404 = nada encontrado, 429 = muitas consultas,
 * 403 = verificação anti-robô recusada.
 *
 * Mascaramento (feito no servidor; nada completo chega ao navegador):
 *   nome       "Mar*** S***"      três letras do primeiro nome e a inicial do sobrenome
 *   documento  "***.456.789-**"   só na busca por CPF; na busca por pedido, omitir
 *   cep        "04538-***"
 *   sem rua, número, complemento, telefone ou e-mail
 *
 * Mapa: pedido.origem { cidade, uf, lat, lng } e pedido.entrega { cidade, uf, lat?, lng? }.
 * Sem origem, usa Limeira/SP (de onde saem os envios da SmartEnvios); sem lat/lng da
 * entrega, usa a capital do estado.
 */
(function () {
  'use strict';

  var STAGES = ['Pagamento', 'Preparação', 'Transporte', 'Entrega'];
  var STAGE_KEYS = ['paid', 'invoiced', 'on_carriage', 'delivered'];
  var MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  var ORIGEM_PADRAO = { cidade: 'Limeira', uf: 'SP', lat: -22.564, lng: -47.401 };
  var DESKTOP = '(min-width: 990px)';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICONS = {
    arrow: '<path d="M7 17 17 7"/><path d="M8.5 7H17v8.5"/>',
    copy: '<rect x="9" y="9" width="11" height="11" rx="2.5"/><path d="M5.5 15H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v.5"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    box: '<path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z"/><path d="M4 7.5 12 12l8-4.5"/><path d="M12 12v9"/>',
    alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    chevron: '<path d="m6 9 6 6 6-6"/>',
    shield: '<path d="M12 3 5 6v5.5c0 4.2 3 7.9 7 9.5 4-1.6 7-5.3 7-9.5V6l-7-3Z"/><path d="m9 12 2 2 4-4"/>',
    wait: '<path d="M7 3h10"/><path d="M7 21h10"/><path d="M8 3c0 5 8 5 8 9s-8 4-8 9"/><path d="M16 3c0 5-8 5-8 9s8 4 8 9"/>',
    map: '<path d="M9 4 3.5 6v14L9 18l6 2 5.5-2V4L15 6 9 4Z"/><path d="M9 4v14"/><path d="M15 6v14"/>'
  };

  function icon(name, cls) {
    return '<svg class="lzr-i' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      ICONS[name] + '</svg>';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function digits(value) {
    return String(value || '').replace(/\D+/g, '');
  }

  function formatCPF(d) {
    d = d.slice(0, 11);
    var out = d.slice(0, 3);
    if (d.length > 3) out += '.' + d.slice(3, 6);
    if (d.length > 6) out += '.' + d.slice(6, 9);
    if (d.length > 9) out += '-' + d.slice(9, 11);
    return out;
  }

  function validCPF(d) {
    if (!/^\d{11}$/.test(d) || /^(\d)\1{10}$/.test(d)) return false;
    for (var t = 9; t < 11; t++) {
      var sum = 0;
      for (var i = 0; i < t; i++) sum += Number(d[i]) * (t + 1 - i);
      if (((sum * 10) % 11) % 10 !== Number(d[t])) return false;
    }
    return true;
  }

  function groupNumber(n) {
    return String(n || '').replace(/(\d{4})(?=\d)/g, '$1 ');
  }

  function money(v) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
    } catch (e) {
      return 'R$ ' + n.toFixed(2).replace('.', ',');
    }
  }

  function parseDay(s) {
    var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  }

  function day(s, withYear) {
    var d = parseDay(s);
    if (!d) return '';
    var out = d.getDate() + ' ' + MONTHS[d.getMonth()];
    if (withYear || d.getFullYear() !== new Date().getFullYear()) out += ' ' + d.getFullYear();
    return out;
  }

  function safeUrl(u) {
    try {
      var url = new URL(u);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (e) {
      return '';
    }
  }

  function sentence(parts) {
    return parts.filter(Boolean).join(' ');
  }

  function place(p) {
    if (!p) return '';
    return p.cidade && p.uf ? p.cidade + '/' + p.uf : p.cidade || p.uf || '';
  }

  /* Status da Yampi -> o que a cliente lê. stage = etapa atual (0..3, -1 fora do caminho);
   * route = onde a caixinha fica no trajeto do mapa (0 na origem, 1 entregue). */
  function model(o) {
    var h = o.historico || {};
    var eta = o.previsao ? 'Previsão de entrega: até ' + day(o.previsao) + '.' : '';
    switch (o.status) {
      case 'waiting_payment':
        return { tone: 'wait', title: 'Aguardando pagamento', stage: 0, progress: 0, route: 0, active: true,
          text: 'Assim que o pagamento for aprovado, começamos a preparar seu pedido.' };
      case 'paid':
        return { tone: 'go', title: 'Pagamento aprovado', stage: 1, progress: 1 / 3, route: 0, active: true,
          text: sentence(['Estamos separando seus produtos para o envio.', eta]) };
      case 'invoiced':
        return { tone: 'go', title: 'Preparando o envio', stage: 1, progress: 0.5, route: 0, active: true,
          text: sentence([h.invoiced ? 'Nota fiscal emitida em ' + day(h.invoiced) + '.' : 'Nota fiscal emitida.',
            'Seu pedido sai nos próximos dias.', eta]) };
      case 'on_carriage':
        return { tone: 'go', title: 'A caminho', stage: 2, progress: 2 / 3, route: 0.6, active: true,
          text: sentence([h.on_carriage ? 'Postado em ' + day(h.on_carriage) + '.' : 'Pedido postado.', eta]) };
      case 'delivered':
        return { tone: 'done', title: 'Entregue', stage: 3, progress: 1, route: 1, active: false,
          text: h.delivered ? 'Entregue em ' + day(h.delivered) + '.' : 'Pedido entregue.' };
      case 'cancelled':
        return { tone: 'off', title: 'Pedido cancelado', stage: -1, route: 0, active: false,
          text: sentence([h.cancelled ? 'Cancelado em ' + day(h.cancelled) + '.' : '',
            'Se você não pediu o cancelamento, fale com a gente.']) };
      case 'refused':
        return { tone: 'off', title: 'Pagamento não aprovado', stage: -1, route: 0, active: false,
          text: 'O pagamento não foi aprovado e o pedido não seguiu. Você pode fazer uma nova compra no site.' };
      default:
        return { tone: 'go', title: 'Pedido recebido', stage: 0, progress: 0, route: 0, active: true, text: '' };
    }
  }

  function carrierPhrase(name) {
    if (!name) return 'Acompanhar entrega';
    return /correios/i.test(name) ? 'Acompanhar nos Correios' : 'Acompanhar na ' + name;
  }

  /* ---------- HTML ---------- */

  function stepsHTML(o, m) {
    var h = o.historico || {};
    var items = '';
    for (var i = 0; i < 4; i++) {
      var state = i < m.stage || m.tone === 'done' ? 'done' : i === m.stage ? 'now' : 'todo';
      var date = state !== 'todo' ? day(h[STAGE_KEYS[i]]) : '';
      var said = state === 'done' ? 'concluído' : state === 'now' ? 'etapa atual' : 'a seguir';
      items += '<li data-s="' + state + '">' + STAGES[i] + '<span class="lzr__sr">: ' + said + '</span>' +
        (date ? '<small>' + esc(date) + '</small>' : '') + '</li>';
    }
    return '<ol class="lzr-steps" aria-label="Etapas do pedido">' + items + '</ol>';
  }

  function thumb(it) {
    var src = safeUrl(it && it.imagem);
    return src
      ? '<img src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy" decoding="async">'
      : icon('box');
  }

  function itemsHTML(list) {
    if (!list || !list.length) return '';
    return '<ul class="lzr-items" aria-label="Produtos do pedido">' + list.map(function (it) {
      var meta = [it.variante, 'Qtd. ' + (it.quantidade || 1)].filter(Boolean).join(' · ');
      return '<li class="lzr-item"><span class="lzr-item__img">' + thumb(it) + '</span>' +
        '<span><span class="lzr-item__name">' + esc(it.nome) + '</span>' +
        '<span class="lzr-item__meta">' + esc(meta) + '</span></span></li>';
    }).join('') + '</ul>';
  }

  /* Rastreio: transportadora, código e o botão. Vem logo depois das etapas no celular. */
  function trackHTML(o, m) {
    var e = o.entrega || {};
    var rows = '';
    if (e.transportadora) rows += '<div><dt class="lzr-k">Transportadora</dt><dd>' + esc(e.transportadora) + '</dd></div>';
    if (e.codigo) {
      rows += '<div><dt class="lzr-k">Código de rastreio</dt><dd class="lzr-code">' +
        '<span class="lzr-code__value">' + esc(e.codigo) + '</span>' +
        '<button type="button" class="lzr-copy" data-lzr-copy="' + esc(e.codigo) + '">' + icon('copy') +
        '<span>Copiar</span></button></dd></div>';
    }
    var action = '';
    var url = safeUrl(e.url);
    if (m.tone !== 'off' && url) {
      var done = m.tone === 'done';
      action = '<a class="lzr__btn' + (done ? ' lzr__btn--ghost' : '') + '" href="' + esc(url) +
        '" target="_blank" rel="noopener noreferrer">' +
        esc(done ? 'Ver histórico da entrega' : carrierPhrase(e.transportadora)) + icon('arrow') +
        '<span class="lzr__sr"> (abre em nova aba)</span></a>';
    } else if (m.tone === 'wait') {
      action = '<p class="lzr-note">' + icon('wait') + '<span>O código de rastreio aparece aqui depois que o pagamento for aprovado e o pedido for postado.</span></p>';
    } else if (m.tone === 'go') {
      action = '<p class="lzr-note">' + icon('clock') + '<span>O código de rastreio aparece aqui assim que o pedido for postado.</span></p>';
    }
    if (!rows && !action) return '';
    return '<div class="lzr-track">' + (rows ? '<dl>' + rows + '</dl>' : '') + action + '</div>';
  }

  /* De onde sai e para onde vai. */
  function placesHTML(o) {
    var e = o.entrega || {};
    var rows = '';
    var where = [place(e), e.cep ? 'CEP ' + e.cep : ''].filter(Boolean).join(' · ');
    if (o.origem || e.cidade || e.uf) {
      rows += '<div><dt class="lzr-k">Sai de</dt><dd>' + esc(place(o.origem || ORIGEM_PADRAO)) + '</dd></div>';
    }
    if (where) rows += '<div><dt class="lzr-k">Entrega em</dt><dd>' + esc(where) + '</dd></div>';
    return rows ? '<dl class="lzr-places">' + rows + '</dl>' : '';
  }

  /* Ordem no DOM = ordem no celular: etapas, rastreio, produtos, lugares. No desktop a grade põe
   * rastreio e lugares na coluna da direita. Dentro de um pedido recolhido o título do estado já está
   * no resumo, então não se repete. */
  function orderInner(o, m, tools, folded) {
    return '<div class="lzr-order__status lzr-order__status--' + m.tone + '">' +
      (folded ? '' : '<h3 class="lzr-order__state">' + esc(m.title) + '</h3>') +
      (m.text ? '<p class="lzr-order__detail">' + esc(m.text) + '</p>' : '') + '</div>' +
      '<div class="lzr-order__body">' +
      (m.stage >= 0 ? '<div class="lzr-order__steps">' + stepsHTML(o, m) + '</div>' : '') +
      trackHTML(o, m) +
      '<div class="lzr-order__items">' + itemsHTML(o.itens) + (tools || '') + '</div>' +
      placesHTML(o) + '</div>';
  }

  function orderHTML(o, hit, onMap) {
    var m = model(o);
    var tools = onMap
      ? '<div class="lzr-order__tools"><button type="button" class="lzr-onmap" data-lzr-onmap="' + esc(o.numero) +
        '" aria-pressed="false">' + icon('map') + '<span>Ver no mapa</span></button></div>'
      : '';
    return '<article class="lzr-order" id="lzr-pedido-' + esc(o.numero) + '" aria-label="Pedido ' + esc(o.numero) + '">' +
      '<header class="lzr-order__head">' +
      '<p class="lzr-order__id"><span class="lzr-order__no">Pedido <span class="lzr-num">' + esc(groupNumber(o.numero)) + '</span></span>' +
      (hit ? '<span class="lzr-tag">Você buscou este</span>' : '') + '</p>' +
      '<p class="lzr-order__meta"><span>Feito em ' + esc(day(o.criado_em, true)) + '</span>' +
      '<span class="lzr-order__total">' + esc(money(o.total)) + '</span></p></header>' +
      orderInner(o, m, tools) + '</article>';
  }

  function foldHTML(o, i) {
    var m = model(o);
    var h = o.historico || {};
    var when = m.tone === 'done' ? day(h.delivered) : day(h.cancelled || o.criado_em);
    var thumbs = (o.itens || []).slice(0, 2).map(function (it) { return '<span>' + thumb(it) + '</span>'; }).join('');
    var meta = [when, 'Pedido …' + String(o.numero || '').slice(-4), money(o.total)].filter(Boolean).join(' · ');
    return '<li class="lzr-rise" style="--i:' + i + '"><details class="lzr-fold"><summary>' +
      '<span class="lzr-fold__thumbs" aria-hidden="true">' + thumbs + '</span>' +
      '<span><span class="lzr-fold__state lzr-fold__state--' + m.tone + '">' + esc(m.title) + '</span>' +
      '<span class="lzr-fold__meta">' + esc(meta) + '</span></span>' +
      '<span class="lzr-fold__chev">' + icon('chevron') + '<span class="lzr__sr">Ver detalhes</span></span>' +
      '</summary><div class="lzr-fold__body">' + orderInner(o, m, '', true) + '</div></details></li>';
  }

  /* Ordem: o buscado primeiro, depois o mais adiantado (o que já tem rastreio). */
  function arrange(data) {
    var hit = data.destaque ? String(data.destaque) : '';
    var orders = (data.pedidos || []).slice().sort(function (a, b) {
      return String(b.criado_em || '').localeCompare(String(a.criado_em || ''));
    });
    var open = orders.filter(function (o) { return model(o).active || String(o.numero) === hit; });
    var past = orders.filter(function (o) { return open.indexOf(o) === -1; });
    open.sort(function (a, b) {
      return ((String(b.numero) === hit) - (String(a.numero) === hit)) || (model(b).progress - model(a).progress);
    });
    return { hit: hit, orders: orders, open: open, past: past };
  }

  function routable(o) {
    var e = o.entrega || {};
    return !!(e.uf || (e.lat != null && e.lng != null && isFinite(e.lat) && isFinite(e.lng)));
  }

  function resultsHTML(data, set) {
    var client = data.cliente || {};
    var count = set.orders.length + (set.orders.length === 1 ? ' pedido' : ' pedidos');
    var meta = [client.documento ? 'CPF ' + client.documento : '', count].filter(Boolean).join(' · ');
    var mapped = set.open.filter(routable);
    var html = '<div class="lzr-who"><div>' +
      '<h2 class="lzr-who__title" tabindex="-1" data-lzr-focus>' + esc(client.nome ? 'Pedidos de ' + client.nome : 'Seus pedidos') + '</h2>' +
      '<p class="lzr-who__meta">' + esc(meta) + '</p></div>' +
      '<button type="button" class="lzr-link" data-lzr-reset>Nova consulta</button></div>';

    if (set.orders.some(routable)) {
      html += '<div class="lzr-map-block"><div class="lzr-map lzr-map--inline" data-lzr-map-slot="results"></div>' +
        '<p class="lzr-map__note">O trajeto mostra a etapa do pedido, não a posição exata do pacote.</p></div>';
    }
    if (set.open.length) {
      html += '<ul class="lzr-list">' + set.open.map(function (o, i) {
        var onMap = mapped.length > 1 && routable(o);
        return '<li class="lzr-rise" style="--i:' + i + '">' + orderHTML(o, set.hit && String(o.numero) === set.hit, onMap) + '</li>';
      }).join('') + '</ul>';
    }
    if (set.past.length) {
      html += '<section class="lzr-past"><h3 class="lzr-past__title">' +
        (set.open.length ? 'Pedidos anteriores' : 'Seus pedidos') + '</h3>' +
        '<ul class="lzr-list lzr-list--tight">' + set.past.map(function (o, i) { return foldHTML(o, i + set.open.length); }).join('') +
        '</ul></section>';
    }
    return html;
  }

  var MESSAGES = {
    vazio: { icon: 'box', title: 'Não encontramos pedidos com esse CPF',
      text: 'A busca mostra os pedidos dos últimos 60 dias. Confira os números do CPF usado na compra. Se preferir, busque pelo número do pedido, que está no e-mail de confirmação.',
      action: 'Corrigir o CPF', kind: 'edit', other: 'pedido', otherLabel: 'Buscar pelo número do pedido' },
    vazioPedido: { icon: 'box', title: 'Não encontramos esse pedido',
      text: 'A busca mostra os pedidos dos últimos 60 dias. Confira o número no e-mail de confirmação da compra. Se preferir, busque pelo CPF usado na compra.',
      action: 'Corrigir o número', kind: 'edit', other: 'cpf', otherLabel: 'Buscar pelo CPF' },
    limite: { icon: 'clock', title: 'Muitas consultas seguidas',
      text: 'Por segurança, pausamos as buscas por alguns instantes. Espere um minuto e tente de novo.',
      action: 'Tentar de novo', kind: 'retry' },
    robo: { icon: 'shield', title: 'Não conseguimos confirmar a consulta',
      text: 'A verificação de segurança não terminou. Recarregue a página e tente de novo.',
      action: 'Recarregar a página', kind: 'reload' },
    erro: { icon: 'alert', title: 'Não conseguimos consultar agora', off: true,
      text: 'Pode ser a conexão ou uma instabilidade do nosso lado. Tente de novo em instantes.',
      action: 'Tentar de novo', kind: 'retry' }
  };

  function messageHTML(key) {
    var msg = MESSAGES[key];
    return '<div class="lzr-msg lzr-rise' + (msg.off ? ' lzr-msg--off' : '') + '">' +
      '<span class="lzr-msg__icon">' + icon(msg.icon) + '</span>' +
      '<h2 class="lzr-msg__title" tabindex="-1" data-lzr-focus>' + esc(msg.title) + '</h2>' +
      '<p>' + esc(msg.text) + '</p>' +
      '<button type="button" class="lzr__btn" data-lzr-' + msg.kind + '>' + esc(msg.action) + '</button>' +
      (msg.other ? '<p><button type="button" class="lzr-link" data-lzr-switch="' + msg.other + '">' + esc(msg.otherLabel) +
        '</button></p>' : '') + '</div>';
  }

  var SKELETON = '<div class="lzr-who"><div><span class="lzr__sr">Buscando seus pedidos</span></div></div>' +
    '<div class="lzr-skel" aria-hidden="true"><i></i><i></i><i></i><i></i></div>' +
    '<div class="lzr-skel" aria-hidden="true"><i></i><i></i><i></i></div>';

  /* ---------- Seção ---------- */

  var TEXT = {
    cpf: {
      label: 'CPF usado na compra',
      placeholder: '000.000.000-00',
      hint: 'Digite só os números.',
      empty: 'Digite o CPF para buscar.',
      invalid: 'Esse CPF não é válido. Confira os números.'
    },
    pedido: {
      label: 'Número do pedido',
      placeholder: 'Ex.: 128985709305516',
      hint: 'Está no e-mail de confirmação da compra.',
      empty: 'Digite o número do pedido.',
      invalid: 'Confira o número do pedido: parece que faltam dígitos.'
    }
  };

  function init(root) {
    if (root.__lzr) return;
    root.__lzr = true;

    var form = root.querySelector('[data-lzr-form]');
    var input = root.querySelector('[data-lzr-input]');
    var label = root.querySelector('[data-lzr-label]');
    var hint = root.querySelector('[data-lzr-hint]');
    var error = root.querySelector('[data-lzr-error]');
    var submit = root.querySelector('[data-lzr-submit]');
    var submitLabel = root.querySelector('[data-lzr-submit-label]');
    var results = root.querySelector('[data-lzr-results]');
    var live = root.querySelector('[data-lzr-live]');
    var captchaBox = root.querySelector('[data-lzr-captcha]');
    var radios = root.querySelectorAll('.lzr__switch input');
    var heroSlot = root.querySelector('[data-lzr-map-slot="hero"]');
    var heroNote = root.querySelector('[data-lzr-map-note]');
    var desktop = window.matchMedia(DESKTOP);

    var cfg = {
      endpoint: root.getAttribute('data-endpoint') || '',
      sitekey: root.getAttribute('data-turnstile') || '',
      mapSrc: root.getAttribute('data-map-src') || '',
      demo: root.getAttribute('data-demo') === 'true'
    };
    var mode = 'cpf';
    var busy = false;
    var last = null;
    var shown = null;

    function announce(text) {
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 60);
    }

    function setMode(next, keepValue) {
      mode = next;
      root.setAttribute('data-mode', next);
      radios.forEach(function (r) { r.checked = r.value === next; });
      label.textContent = TEXT[next].label;
      input.placeholder = TEXT[next].placeholder;
      hint.textContent = TEXT[next].hint;
      if (!keepValue) input.value = '';
      clearError();
    }

    function showError(text) {
      error.innerHTML = icon('alert') + '<span>' + esc(text) + '</span>';
      error.hidden = false;
      hint.hidden = true;
      input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      error.hidden = true;
      error.textContent = '';
      hint.hidden = false;
      input.removeAttribute('aria-invalid');
    }

    function setBusy(on) {
      busy = on;
      submit.setAttribute('aria-busy', on ? 'true' : 'false');
      submitLabel.textContent = on ? 'Buscando…' : 'Ver meus pedidos';
      input.readOnly = on;
    }

    /* ---------- Mapa 3D ---------- */

    var map = { lib: null, loading: null, stage: null, slot: null, failed: false, chip: null };

    function loadMap() {
      if (map.loading) return map.loading;
      map.loading = new Promise(function (resolve, reject) {
        if (window.LZRMapa) return resolve(window.LZRMapa);
        if (!cfg.mapSrc) return reject(new Error('sem mapa'));
        var script = document.createElement('script');
        script.src = cfg.mapSrc;
        script.async = true;
        script.onload = function () { if (window.LZRMapa) resolve(window.LZRMapa); else reject(new Error('mapa')); };
        script.onerror = reject;
        document.head.appendChild(script);
      }).then(function (lib) {
        map.lib = lib;
        return lib;
      });
      return map.loading;
    }

    function mapSlot() {
      return desktop.matches ? heroSlot : results.querySelector('[data-lzr-map-slot="results"]');
    }

    function mountMap() {
      var slot = mapSlot();
      if (!slot || map.failed) return Promise.resolve(null);
      return loadMap().then(function (lib) {
        if (map.stage && map.slot === slot) return map.stage;
        if (map.stage) map.stage.dispose();
        map.stage = null;
        try {
          map.stage = lib.create(slot, { reduced: REDUCED });
        } catch (e) {
          map.failed = true;
          slot.hidden = true;
          return null;
        }
        map.slot = slot;
        map.chip = document.createElement('p');
        map.chip.className = 'lzr-map__chip';
        map.chip.hidden = true;
        slot.appendChild(map.chip);
        return map.stage;
      }, function () {
        map.failed = true;
        return null;
      });
    }

    function routeOf(o) {
      var e = o.entrega || {};
      var from = o.origem || ORIGEM_PADRAO;
      var cap = map.lib && map.lib.CAPITAIS[e.uf];
      var to = e.lat != null && e.lng != null && isFinite(e.lat) && isFinite(e.lng) ? [Number(e.lat), Number(e.lng)] : cap;
      if (!to) return null;
      var m = model(o);
      return {
        from: { lat: Number(from.lat), lng: Number(from.lng), label: place(from) },
        to: { lat: to[0], lng: to[1], label: place(e) || e.uf, uf: e.uf },
        progress: m.route,
        muted: m.tone === 'off',
        chip: { state: m.title, meta: 'Pedido …' + String(o.numero || '').slice(-4) + (o.previsao && m.active ? ' · até ' + day(o.previsao) : '') }
      };
    }

    function showOnMap(o, animate) {
      shown = o;
      results.querySelectorAll('[data-lzr-onmap]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-lzr-onmap') === String(o.numero) ? 'true' : 'false');
      });
      return mountMap().then(function (stage) {
        if (!stage || shown !== o) return;
        var info = routeOf(o);
        if (!info) return;
        stage.route(info, animate);
        map.chip.innerHTML = '<span class="lzr-map__chip-state">' + esc(info.chip.state) + '</span>' +
          '<span class="lzr-map__chip-meta">' + esc(info.chip.meta) + '</span>';
        map.chip.hidden = false;
        if (heroNote) heroNote.hidden = !desktop.matches;
      });
    }

    function mapOverview() {
      shown = null;
      if (heroNote) heroNote.hidden = true;
      if (map.chip) map.chip.hidden = true;
      if (desktop.matches) {
        mountMap().then(function (stage) {
          if (stage) stage.overview(!REDUCED, { lat: ORIGEM_PADRAO.lat, lng: ORIGEM_PADRAO.lng, label: place(ORIGEM_PADRAO) });
        });
      } else if (map.stage) {
        map.stage.dispose();
        map.stage = null;
        map.slot = null;
      }
    }

    /* Ao cruzar 990px o mapa troca de lugar: topo da página (desktop) ou topo do resultado (celular). */
    function onBreakpoint() {
      if (map.stage) {
        map.stage.dispose();
        map.stage = null;
        map.slot = null;
      }
      if (shown) showOnMap(shown, false);
      else if (desktop.matches) mapOverview();
    }
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);

    /* ---------- Formulário ---------- */

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) {
          setMode(r.value);
          input.focus();
        }
      });
    });

    input.addEventListener('input', function () {
      var d = digits(input.value);
      if (mode === 'cpf' && d.length > 11) {
        setMode('pedido', true);
        input.value = d.slice(0, 20);
        hint.textContent = 'Esse número é longo para um CPF, então mudamos para a busca por pedido.';
        return;
      }
      input.value = mode === 'cpf' ? formatCPF(d) : d.slice(0, 20);
      if (!error.hidden) clearError();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      var d = digits(input.value);
      var problem = !d ? TEXT[mode].empty
        : mode === 'cpf' && !validCPF(d) ? TEXT.cpf.invalid
        : mode === 'pedido' && d.length < 6 ? TEXT.pedido.invalid
        : '';
      if (problem) {
        showError(problem);
        input.focus();
        return;
      }
      clearError();
      if (document.activeElement === input && window.matchMedia('(pointer: coarse)').matches) input.blur();
      search(mode, d);
    });

    results.addEventListener('click', function (event) {
      var copy = event.target.closest('[data-lzr-copy]');
      if (copy) return copyCode(copy);
      var onmap = event.target.closest('[data-lzr-onmap]');
      if (onmap && last && last.set) {
        var num = onmap.getAttribute('data-lzr-onmap');
        var order = last.set.orders.filter(function (o) { return String(o.numero) === num; })[0];
        if (order) {
          showOnMap(order, true);
          (desktop.matches ? root.querySelector('[data-lzr-stage]') : results.querySelector('.lzr-map-block'))
            .scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      if (event.target.closest('[data-lzr-reset]')) return reset();
      if (event.target.closest('[data-lzr-retry]')) {
        if (last) search(last.tipo, last.valor);
        return;
      }
      var other = event.target.closest('[data-lzr-switch]');
      if (other) {
        setMode(other.getAttribute('data-lzr-switch'));
        form.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
        return;
      }
      if (event.target.closest('[data-lzr-edit]')) {
        form.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
        input.select();
        return;
      }
      if (event.target.closest('[data-lzr-reload]')) window.location.reload();
    });

    function copyCode(button) {
      var code = button.getAttribute('data-lzr-copy');
      var done = function () {
        button.setAttribute('data-copied', '');
        button.innerHTML = icon('check') + '<span>Copiado</span>';
        announce('Código de rastreio copiado.');
        window.setTimeout(function () {
          button.removeAttribute('data-copied');
          button.innerHTML = icon('copy') + '<span>Copiar</span>';
        }, 1800);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done, function () { legacyCopy(code) && done(); });
      } else if (legacyCopy(code)) {
        done();
      }
    }

    function legacyCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(area);
      return ok;
    }

    function reset() {
      results.hidden = true;
      results.innerHTML = '';
      input.value = '';
      clearError();
      updateUrl(null);
      mapOverview();
      form.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      input.focus({ preventScroll: true });
    }

    function updateUrl(pedido) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (pedido) url.searchParams.set('pedido', pedido);
      else url.searchParams.delete('pedido');
      window.history.replaceState(window.history.state, '', url.toString());
    }

    /* Turnstile invisível: carrega só quando há chave e a seção não está em demonstração. */
    var ts = { id: null, token: null, waiting: [] };

    function bootTurnstile() {
      if (!cfg.sitekey || cfg.demo) return;
      var render = function () {
        ts.id = window.turnstile.render(captchaBox, {
          sitekey: cfg.sitekey,
          action: 'rastreio',
          appearance: 'interaction-only',
          size: 'flexible',
          language: 'pt-br',
          'refresh-expired': 'auto',
          callback: function (token) {
            ts.token = token;
            while (ts.waiting.length) ts.waiting.shift()(token);
          },
          'expired-callback': function () { ts.token = null; },
          'error-callback': function () { ts.token = null; }
        });
      };
      if (window.turnstile) return render();
      window.__lzrTurnstile = window.__lzrTurnstile || [];
      window.__lzrTurnstile.push(render);
      window.lzrTurnstileReady = function () {
        while (window.__lzrTurnstile.length) window.__lzrTurnstile.shift()();
      };
      if (!document.querySelector('script[data-lzr-turnstile]')) {
        var script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=lzrTurnstileReady';
        script.async = true;
        script.defer = true;
        script.setAttribute('data-lzr-turnstile', '');
        document.head.appendChild(script);
      }
    }

    function getToken() {
      if (!cfg.sitekey || cfg.demo) return Promise.resolve(null);
      if (ts.token) {
        var token = ts.token;
        ts.token = null;
        return Promise.resolve(token);
      }
      return new Promise(function (resolve) {
        ts.waiting.push(resolve);
        window.setTimeout(function () { resolve(null); }, 10000);
      });
    }

    function resetTurnstile() {
      if (ts.id != null && window.turnstile) {
        try { window.turnstile.reset(ts.id); } catch (e) { /* widget já removido */ }
      }
    }

    /* O arquivo de demonstração carrega depois deste; o link direto pode buscar antes dele existir. */
    function demoReady() {
      return new Promise(function (resolve) {
        var tries = 0;
        (function check() {
          if (window.LZR_DEMO || tries++ > 60) return resolve(window.LZR_DEMO || null);
          window.setTimeout(check, 50);
        })();
      });
    }

    function request(tipo, valor, token) {
      if (cfg.demo) {
        return demoReady().then(function (demo) {
          return demo ? demo.lookup(tipo, valor) : { status: 503, body: {} };
        });
      }
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
      return fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ tipo: tipo, valor: valor, token: token }),
        credentials: 'omit',
        cache: 'no-store',
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        window.clearTimeout(timer);
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { status: res.status, body: body };
        });
      }, function (err) {
        window.clearTimeout(timer);
        throw err;
      });
    }

    function search(tipo, valor) {
      last = { tipo: tipo, valor: valor };
      setBusy(true);
      results.hidden = false;
      results.setAttribute('aria-busy', 'true');
      results.innerHTML = SKELETON;
      announce('Buscando seus pedidos.');

      getToken()
        .then(function (token) { return request(tipo, valor, token); })
        .then(function (res) {
          var body = res.body || {};
          if (res.status === 200 && body.pedidos && body.pedidos.length) {
            if (!body.destaque && tipo === 'pedido') body.destaque = valor;
            var set = arrange(body);
            last.set = set;
            show(resultsHTML(body, set));
            var focus = set.open.filter(routable)[0] || set.orders.filter(routable)[0];
            if (focus) showOnMap(focus, true);
            else mapOverview();
            updateUrl(tipo === 'pedido' ? valor : null);
            var n = body.pedidos.length;
            announce(n === 1 ? '1 pedido encontrado.' : n + ' pedidos encontrados.');
          } else {
            var key = res.status === 200 || res.status === 404 ? (tipo === 'pedido' ? 'vazioPedido' : 'vazio')
              : res.status === 429 ? 'limite'
              : res.status === 403 ? 'robo'
              : 'erro';
            show(messageHTML(key));
            mapOverview();
            announce(MESSAGES[key].title + '.');
          }
        })
        .catch(function () {
          show(messageHTML('erro'));
          announce(MESSAGES.erro.title + '.');
        })
        .then(function () {
          setBusy(false);
          resetTurnstile();
        });
    }

    function show(html) {
      results.removeAttribute('aria-busy');
      results.innerHTML = html;
      var heading = results.querySelector('[data-lzr-focus]');
      if (heading) heading.focus({ preventScroll: true });
      if (!desktop.matches) results.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    }

    bootTurnstile();

    /* No desktop o Brasil aparece ao lado da busca; o Three.js só carrega depois que a página pintou. */
    if (desktop.matches) {
      var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 400); };
      idle(function () { if (!shown) mapOverview(); });
    }

    /* Link direto: /pages/rastreio?pedido=128985709305516 já abre o pedido. */
    var linked = digits(new URLSearchParams(window.location.search).get('pedido'));
    if (linked.length >= 6) {
      setMode('pedido');
      input.value = linked;
      search('pedido', linked);
    }
  }

  function start() {
    document.querySelectorAll('[data-lzr]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
